import request from './api';
import {
  API,
  API_USER,
  API_DEPARTMENT_TEAM,
  API_USER_LIST_TEAM,
  API_LEGAL,
  API_PROFILE,
  API_CMS_PUBLIC
} from '../constants/api';

export const getUser = () => request(`${API}connected`);
export const getUserDetails = () => request(`${API_USER}user/me`);
export const getUserDetailsById = userId =>
  request(`${API_USER}user/${userId}`);
export const getMyTeamOld = departmentId =>
  request(API_DEPARTMENT_TEAM.replace('0000', departmentId), { method: 'GET' });

export const getMyTeam = departmentId =>
  request(`${API_USER_LIST_TEAM}/${departmentId}`);

export const getImgSociety = userId =>
  request(`${API_USER}user/username/imgSociety/${userId}`);

export const setUserEditingData = userUpdatedData =>
  request(`${API_USER}user`, {
    method: 'PUT',
    data: userUpdatedData
  });

export const checkPassword = password =>
  request(`${API}passwordVerify`, {
    method: 'POST',
    data: {
      password
    }
  });

export const getToken = () => request(`${API}/token`);

export const setAvatar = id =>
  request(`${API_USER}avatar?avatarId=${id}`, {
    method: 'PUT'
  });

export const createCrops = data =>
  request(`${API_CMS_PUBLIC}images/avatar/crop`, {
    method: 'POST',
    data
  });

export const setImageAvatar = (token, type, crops = null) => {
  request(`${API_CMS_PUBLIC}images/avatar/default?file=${token}.${type}`, {
    method: 'POST'
  })
    .then(() => createCrops(crops))
    .catch(err => {
      console.warn(err);
    });
};

export const uploadAvatarImage = (data, type, crops = null) => {
  request(`${API_CMS_PUBLIC}upload`, {
    method: 'POST',
    headers: { 'Content-Type': 'multipart/form-data' },
    data
  })
    .then(res => {
      if (crops) {
        setImageAvatar(res, type, crops);
      }
      return res;
    })
    .catch(err => {
      console.warn(err);
    });
};

export const updateAvatarHeaderImage = userId =>
  `${API_USER}hcm/hcm-avatar?userId=${userId}`;

export const isPhoto = async userId => {
  const callImage = `${API_USER}hcm/hcm-avatar?userId=${userId}`;

  request(callImage, {
    method: 'GET'
  });
};

export const setLegalCondition = () => {
  request(`${API_LEGAL}?legalConditions=true`, {
    method: 'POST'
  });
};

export const setFormUserModal = data => {
  request(`${API_PROFILE}user/filledDataUser?filledDataUser=true`, {
    method: 'POST',
    data
  });
};

export const setWelcomePage = () => {
  request(`${API_PROFILE}user/welcomePage?welcomePage=true`, {
    method: 'POST'
  });
};

export const getSocieties = () => request(`${API_USER}/society/meta4`);
